import { api_configuration } from "../../common";
import ImplementationVisitorContext from "./ImplementationVisitorContext";
import api_widget = api_configuration.libraries.gui_definition_lib.types.widget.alan_api;

export function decorateInstructionError(
	error: Error,
	instruction: api_widget.Cinstruction_selection,
	implementation_context: ImplementationVisitorContext
): Error {
	markErrorAsDecorated(error);
	const old_message = error.message;
	error.message = `Exception at instruction:${instruction.root.key} ${instruction.path}${tryGetApplicationContext(
		implementation_context
	)}
at gui config:${implementation_context.widget_configuration.path}
${tryGetInstructionDetails(instruction)}
${old_message}`;
	return error;
}

export function decorateControlError(
	error: Error,
	control_binding: api_widget.Ccontrol_binding,
	implementation_context: ImplementationVisitorContext
): Error {
	markErrorAsDecorated(error);
	const old_message = error.message;
	error.message = `Exception at widget:${control_binding.root.key} ${control_binding.path}${tryGetApplicationContext(
		implementation_context
	)}
at gui config:${implementation_context.widget_configuration.path}
${old_message}`;
	return error;
}

function tryGetApplicationContext(implementation_context: ImplementationVisitorContext): string {
	if (global.logClientStateOnError) {
		try {
			return "\nat context:" + implementation_context.current_binding_context.path;
		} catch (e) {
			return "";
		}
	}
	return "";
}

function tryGetInstructionDetails(instruction: api_widget.Cinstruction_selection): string {
	try {
		return instruction.properties.configuration_attribute_type.switch({
			binding: ($) => "instruction: " + $.properties.instruction.entry,
			configuration: ($) => {
				return $.properties.instruction.switch({
					"set number": ($) => "set number: " + $.properties.number.entry,
					"set state": ($) => "set state: " + $.properties.state_group.entry + " : " + $.properties.state.entry,
					"set text": ($) => "set text: " + $.properties.text.entry,
				});
			},
		});
	} catch (e) {
		return "";
	}
}

function markErrorAsDecorated(e: Error) {
	(e as any)._alan_decorated = true;
}

export function isNonDecoratedError(e: any) {
	return e instanceof Error && (e as any)._alan_decorated !== true;
}
